<template>
    <div>
        <div class="filter_overlay" :class="{ cyo_jew_mobile: showFilter }">
            <div class="filter_block">
                <div class="filter_block_left">
                    <div class="for_mobile filter_header">
                        <div class="close_title">
                            <SvgHeaderSvg class="for_mobile" :type="'filter_burger'" />
                            <p class="mb-0">Filters</p>
                        </div>
                        <div class="filter_close">
                            <div class="reset" @click="resetFilter(filters)"> <SvgHeaderSvg :type="'loader_mob'" />Reset</div>
                            <div class="" @click="toggleFilterVisibility()">
                                <SvgHeaderSvg :type="'close'" />
                            </div>
                        </div>
                    </div>
                    <div class="flex-wrap w-100 d-flex align-items-center filters_container">
                        <div class="filter_box">
                            <InspirationFiltersDropDownFilter @selectOption="selectOption" @resetFilter="resetFilter"
                                :filters="filters.metal_color" :label="'metals'" />
                        </div>
                        <div class="filter_box">
                            <InspirationFiltersDropDownFilter @selectOption="selectOption" @resetFilter="resetFilter"
                                :filters="filters.style" :label="'styles'" />
                        </div>
                        <div class="filter_box">
                            <InspirationFiltersDropDownFilter @selectOption="selectOption" @resetFilter="resetFilter"
                                :filters="filters.shape" :label="'shapes'" />
                        </div>
                        <div class="filter_box">
                            <InspirationFiltersDropDownFilter @selectOption="selectOption" @resetFilter="resetFilter"
                                :filters="filters.carat" :label="'carats'" />
                        </div>
                    </div>
                </div>
                <div class="filter_block_right for_desktop">
                    <div class="filter_box ">
                        <div class="sort_search">
                            <SvgHeaderSvg :type="'search'" class="input-icon" />
                            <input type="text" v-model="props.searchTerm" @input="searchOption" placeholder="Name / Sku" class="input-with-icon">
                        </div>
                    </div>
                    <div class="filter_box">
                        <InspirationFiltersSortByFilter @selectOption="selectOption" :filters="filters.sort_by"
                            :label="'Sort By'" />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showFilter" class="for_mobile sticky_btns">
            <CommonButtonPrimary @emit-event="toggleFilterVisibility()">
                <SvgHeaderSvg :type="'filter'" /> <span class="ms-2">FILTER RESULTS </span>
            </CommonButtonPrimary>
        </div>
        <div v-else class="for_mobile sticky_btns sticky_btns_mod">
            <CommonButtonPrimary @emit-event="toggleFilterVisibility()"><span>APPLY FILTERS </span></CommonButtonPrimary>
        </div>

        <div class="filter_tags_sort">
            <InspirationFiltersInspirationPlates :selected-filters="selectedFilters" @resetFilter="resetFilter"/>

            <div class="sort for_mobile">
                <div class="prod_view">
                    <!-- <div class="d-flex">
                    <div class="grid_view" @click="changeViewType('grid')" :class="{'active': viewType === 'grid'}"><SvgHeaderSvg :type="'grid'" /></div>
                    <div class="grid_view" @click="changeViewType('list')" :class="{'active': viewType === 'list'}"><SvgHeaderSvg :type="'list'" /></div>
                    </div> -->
                </div>
                <div class="sort_drops">
                    <InspirationFiltersSortByFilter @selectOption="selectOption" :filters="filters.sort_by"
                        :label="'Sort By'" />
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>

    import debounce from 'debounce';

    const props = defineProps(['filters','searchTerm'])

    
    const emit = defineEmits(['selectOption', 'resetFilter', 'searchOption', 'changeViewType'])

    const showFilter = ref(true)

    const toggleFilterVisibility = () => {
        showFilter.value = !showFilter.value
        if (showFilter.value) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
    
    const selectOption = (value) => {
        emit('selectOption',value)
    }
    
    const excludedDefaults = new Set(['All Metals', 'All Styles', 'All Shapes', 'All Carats']);

    const selectedFilters = computed(() => {
            let selected = [];
            for (let key in props.filters) {
                if (key === 'sort_by') continue;
                let filterGroup = props.filters[key];

                let nonDefaultActive = filterGroup.some(filter => filter.active && filter.value !== '' && !excludedDefaults.has(filter.label));

                filterGroup.forEach(filter => {
                 
                    if (filter.active && (filter.value !== '' || !nonDefaultActive) && !excludedDefaults.has(filter.label)) {
                        selected.push({ label: key, value: filter.label, active : filter.active });
                    }
                });
            }
            return selected;
    });

    const resetFilter = (filters) => {
        emit('resetFilter', filters)
    }

    const searchOption = debounce((e) => {
        const searchTerm = e.target.value;
        emit('searchOption', searchTerm);
    }, 1000);

    function changeViewType(type) {
  
        emit('changeViewType', type)
    }

</script>


<style scoped>
input {
    max-width: 100%;
}

input:focus {
    outline: none;
}
::placeholder{
    font-size: 14px;
    color: #909090;
}
.sort_search {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    padding: 7px 12px;
    cursor: pointer;
    max-width: 150px;
}

.input-with-icon {
    padding-left: 25px;
    border: 0;
}

.input-icon {
    position: absolute;
    left: 15px;
    top: 55%;
    transform: translateY(-50%);
    pointer-events: none;
}

.active.grid_view .svg-head {
    color: var(--green);
}
.filter_tags{
    background: #f0f3f3;
    min-height: 53px;
    border-radius: 8px;
    padding: 12px 16px 4px 16px;
}
.filter_block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.filter_block_left {
    display: flex;
    align-items: flex-start;
}

.sticky_btns button {
    width: 100%;
}

.filter_block_right {
    display: flex;
    justify-content: end;
    gap: 10px;
}

.filter_block_right .filter_box {
    margin-right: 0;
}

.filter_box {
    margin-right: 20px;
}

.sticky_btns button:focus {
    box-shadow: none;
}

.filter_tags_sort {
    margin: 2% 0;
}


@media(max-width: 992px) {
    .col {
        padding: 0 0.5%;
    }

    .filter_block {
        display: flex;
        align-items: stretch;
        justify-content: space-evenly;
        flex-direction: column;
        gap: 15px;
    }
}

@media(max-width: 767px) {

    .filter_header {
        display: flex !important;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 20px;
        margin-bottom: 20px;
        padding:4%;
    }

    .close_title {
        display: flex;
        align-items: center;
    }

    .close_title p {
        font-size: 14px;
        font-weight: 600;
    }

    .reset {
        margin-right: 20px;
    }

    .close_title svg.svg-head {
        height: 15px;
        margin-right: 10px;
    }

    .filter_block_left {
        flex-wrap: wrap;
        width: 100%;
    }

    .filter_box {
        width: 100%;
        margin-right: 0;
    }

    .sticky_btns.sticky_btns_mod {
        z-index: 99;
        padding: 0;
    }

    .sticky_btns.sticky_btns_mod button{
        border-radius: 0;
    }

    .reset .svg-head {
        height: 16px;
    }

    .reset {
        font-size: 14px;
        font-weight: 600;
    }

    .filter_close svg {
        /* transform: scale(1.3);
        margin-right: 10px; */
    }

    .current_active {
        padding: 0;
    }

    .filter_close {
        display: flex;
        align-items: baseline;
        justify-content: flex-end;
    }

    .sticky_btns {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        z-index: 9;
        padding: 16px 16px 16px 16px;
        border-radius: 16px 16px 0px 0px;
        background-color: #fff;
        box-shadow: 0px -2px 10px 0px #00000026;
    }

    .filter_overlay {
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100%;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 99;
        display: flex;
        align-items: flex-end;
    }


    @media screen and (max-width: 767px) {
        .cyo_jew_mobile.filter_overlay {
            /* visibility: hidden;
        clear: both;
        float: left;*/
            /*    margin: 10px auto 5px 20px;*/
            /*    width: 28%;*/
            display: none;
        }
    }

    .filter_block {
        background: #fff;
        /* padding: 4%; */
        width: 100%;
        margin: 0 auto;
        border-radius: 15px 15px 0 0;
        margin-bottom: 40px;
        height: auto;
        /* overflow: auto; */
        overflow: hidden;
        max-height: 80vh;
        padding-bottom: 20%;
    }

    .filters_container{
        padding: 4%;
        padding-top:0;
        max-height: 80vh;
        overflow-y: scroll;
        padding-bottom: 100px;
    }

    /* ////////////////////// */
    .sort {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        background: #f5f5f5;
        width: 100%;
        padding: 0 10px;
        height: 45px;
        border-radius: 8px;
    }

    .grid_view {
        margin-right: 10px;
    }
}
</style>